// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"497":"4b5b495e","611":"b683e3a9"}[chunkId] + ".chunk.css";
};